var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAvatar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 143,
    viewBox: "0 0 195 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 142,
    rx: 6.85714,
    fill: "#FE9A79"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_482_3774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.611 104.923L68.2568 104.86C64.9464 104.847 62.2691 102.16 62.252 98.8752L62.2617 44.0758C62.2706 40.7693 64.9581 38.0981 68.2466 38.0847L125.601 38.1479C128.911 38.1605 131.588 40.8478 131.606 44.1325L131.596 98.9318C131.587 102.238 128.899 104.909 125.611 104.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2584 104.439L125.609 104.502C125.61 104.502 125.61 104.502 125.61 104.502C128.667 104.489 131.166 102.005 131.175 98.9305L131.184 44.1346C131.184 44.1342 131.184 44.1338 131.184 44.1334C131.168 41.0799 128.678 38.5808 125.6 38.5685L68.2584 104.439ZM68.2584 104.439C68.258 104.439 68.2576 104.439 68.2573 104.439C65.1795 104.427 62.6897 101.928 62.6731 98.8743C62.6731 98.8739 62.6731 98.8735 62.6731 98.8731L62.6829 44.0771C62.6829 44.0769 62.6829 44.0768 62.6829 44.0767C62.6913 41.0023 65.1904 38.5184 68.2473 38.5053C68.2477 38.5053 68.248 38.5053 68.2484 38.5053L125.599 38.5685L68.2584 104.439Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.84173
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.45 96.7162L72.0308 96.6804C70.6046 96.6813 69.4661 95.5476 69.4636 94.1231L69.4565 48.8339C69.454 47.4094 70.5878 46.2734 72.014 46.2726L122.433 46.3083C123.859 46.3074 124.998 47.4411 125 48.8657L125.007 94.1548C125.01 95.5793 123.876 96.7153 122.45 96.7162Z",
    fill: "#FFDDD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0405 64.477C90.5049 63.2401 90.6869 61.0505 89.4469 59.5864C88.2069 58.1223 86.0145 57.9381 84.5501 59.175C83.0856 60.4118 82.9036 62.6015 84.1436 64.0656C85.3836 65.5297 87.576 65.7139 89.0405 64.477Z",
    fill: "#FE9A79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1442 79.5056L79.9504 79.4844L84.4982 74.3585L86.7721 71.7955L89.046 69.2325L91.3205 71.8008L93.5951 74.3691L98.1442 79.5056Z",
    fill: "#75CE9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0246 70.3293L89.5472 70.0506L89.274 70.2982L88.6401 70.1035L88.0747 70.3271L88.5621 69.7777L88.8058 69.503L89.0495 69.2283L89.2933 69.5036L89.5371 69.7788L90.0246 70.3293Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.466 79.5349L86.9518 79.504L93.5792 72.034L96.8929 68.2989L100.207 64.5639L103.521 68.3066L106.836 72.0494L113.466 79.5349Z",
    fill: "#A3DFBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.632 66.1699L100.936 65.7637L100.538 66.1246L99.6142 65.8407L98.7902 66.1666L99.5005 65.366L99.8557 64.9657L100.211 64.5654L100.566 64.9665L100.921 65.3676L101.632 66.1699Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_482_3774",
    x: 44.462,
    y: 29.185,
    width: 104.934,
    height: 102.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.895
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_482_3774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_482_3774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAvatar2);
export default __webpack_public_path__ + "static/media/productAvatar2.2eb6e4d4a0947133381c2ae26c04659d.svg";
export { ForwardRef as ReactComponent };